import { logger } from './logger.js';

const API_BASE = import.meta.env.VITE_API_BASE_URL || '/gustumejo/001/api';

async function http(method, path, body, headers = {}) {
  const requestId = crypto.randomUUID();
  logger.debug('API request started', { method, path, requestId });
  const response = await fetch(`${API_BASE}${path}`, { method, credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'X-Request-Id': requestId, ...headers }, body: body ? JSON.stringify(body) : undefined });
  if (!response.ok) { let payload = {}; try { payload = await response.json(); } catch (_) {} logger.warn('API request failed', { method, path, status: response.status, requestId: payload.requestId || response.headers.get('X-Request-Id') }); const error = new Error(payload.error || `HTTP_${response.status}`); error.status = response.status; throw error; }
  logger.trace('API request completed', { method, path, status: response.status, requestId: response.headers.get('X-Request-Id') });
  const text = await response.text();
  return text ? JSON.parse(text) : null;
}

export const api = {
  session: (panel) => http('GET', `/session?panel=${encodeURIComponent(panel)}`),
  ranking: (panel) => http('GET', `/ranking?panel=${encodeURIComponent(panel)}`),
  saveRanking: (panel, data) => http('PUT', `/ranking?panel=${encodeURIComponent(panel)}`, data),
  rankingSummary: (panel) => http('GET', `/ranking-summary?panel=${encodeURIComponent(panel)}`),
  bootstrap: (key, data) => http('POST', '/auth/bootstrap', data, { 'X-Admin-Key': key }),
  bootstrapStatus: () => http('GET', '/auth/bootstrap-status'),
  login: (data) => http('POST', '/auth/login', data),
  changePassword: (data) => http('POST', '/auth/password', data),
  requestPasswordReset: (data) => http('POST', '/auth/password-reset', data),
  confirmPasswordReset: (token, data) => http('POST', `/auth/password-reset/${token}`, data),
  logout: () => http('POST', '/auth/logout'),
  me: () => http('GET', '/auth/me'),
  activate: (token, data) => http('POST', `/auth/activate/${token}`, data),
  myPanels: () => http('GET', '/my/panels'),
  adminPanels: () => http('GET', '/admin/panels'),
  createPanel: (data) => http('POST', '/admin/panels', data),
  updateBlind: (slug, body) => http('PUT', `/admin/panels/${slug}/blind`, body),
  updatePanelDate: (slug, tastingDate) => http('PUT', `/admin/panels/${slug}/date`, { tastingDate }),
  updatePanelKriterien: (slug, kriterien) => http('PUT', `/admin/panels/${slug}/kriterien`, { kriterien }),
  addTeilnehmer: (slug, data) => http('POST', `/admin/panels/${slug}/teilnehmer`, data),
  produkte: () => http('GET', '/admin/produkte'),
  produkt: (key) => http('GET', `/admin/produkte/${encodeURIComponent(key)}`),
  createProdukt: (data) => http('POST', '/admin/produkte', data),
  createKriterium: (key, data) => http('POST', `/admin/produkte/${encodeURIComponent(key)}/kriterien`, data),
  updateKriterium: (key, schluessel, data) => http('PUT', `/admin/produkte/${encodeURIComponent(key)}/kriterien/${encodeURIComponent(schluessel)}`, data),
  setStufe: (key, stufe, kriterien) => http('PUT', `/admin/produkte/${encodeURIComponent(key)}/stufen/${stufe}`, { kriterien }),
  adminUsers: () => http('GET', '/admin/users'),
  createUser: (data) => http('POST', '/admin/users', data),
  updateUser: (id, data) => http('PUT', `/admin/users/${id}`, data),
  assignUser: (slug, userId) => http('POST', `/admin/panels/${slug}/users/${userId}`),
  panelUsers: (slug) => http('GET', `/admin/panels/${slug}/user-ids`),
  invitation: (userId, panel) => http('POST', `/admin/users/${userId}/invitation?panel=${encodeURIComponent(panel)}`),
  adminOils: () => http('GET', '/admin/oils'),
  createOil: (data) => http('POST', '/admin/oils', data),
  updateOil: (id, data) => http('PUT', `/admin/oils/${id}`, data),
  assignOil: (slug, oilId, sortOrder) => http('POST', `/admin/panels/${slug}/oils/${oilId}?sortOrder=${sortOrder}`),
  panelOils: (slug) => http('GET', `/admin/panels/${slug}/oil-ids`),
  researchOil: (data) => http('POST', '/admin/research', data),
  applyResearch: (id, result) => http('POST', `/admin/oils/${id}/research`, { result }),
  oilImages: (id) => http('GET', `/admin/oils/${id}/images`),
  settings: () => http('GET', '/admin/settings'),
  updateSettings: (data) => http('PUT', '/admin/settings', data),
  sendTestMail: () => http('POST', '/admin/mail/test')
};

export async function imageResearch(kind, file, oilId) {
  const requestId = crypto.randomUUID();
  const form = new FormData(); form.append('kind', kind); form.append('file', file); if (oilId) form.append('oilId', oilId);
  const response = await fetch(`${API_BASE}/admin/image-research`, { method: 'POST', credentials: 'same-origin', headers: { 'X-Request-Id': requestId }, body: form });
  if (!response.ok) { const payload = await response.json().catch(() => ({})); throw new Error(payload.error || `HTTP_${response.status}`); }
  return response.json();
}
